import React from 'react';
import Heading from 'comps/heading';
import styled from 'styled-components';
import { Button, Dropdown, Separator, Text, TextInput } from '@cuemath/web-comps';
import { COLORS, Row } from '@cuemath/comps';
import moment from 'moment';
import { FileUpload } from 'styled-icons/material';
import ReportList from './components/report-list';
import PropTypes from 'prop-types';

const Container = styled.div`
  padding: 24px 16px;
`;

const InputContainer = styled.div`
  width: 250px;
`;

const Upload = styled(FileUpload)`
  cursor: pointer;
`;

const View = ({
  formData,
  handleUpload,
  getEventsState,
  handleFormChange,
  handleGetFestReport,
  eventDropdownOptions,
  uploadingFileInProgress,
  getReportDetailsInProgress,
  previouslyUploadedReports,
  sendCommsToParticipants,
}) => {
  const { date, eventName, eventDataFile, certificateEventName } = formData || {};
  const formattedDate = moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY');
  const fileName = eventDataFile && eventDataFile.name;

  return (
    <Container>
      <Heading>Delta Quiz Report Management</Heading>
      <Text variant="body2">Upload and manage Kahoot quiz reports</Text>
      <Separator height={24} />
      <TextInput
        onChange={value => handleFormChange('date', value)}
        width="250px"
        type="date"
        label="Date of the event"
        name={'event-date'}
        value={date || ''}
      />
      {getEventsState?.isLoading && (
        <Text variant="body2" color={COLORS.PRIMARY}>
          Loading all available events on {formattedDate}...
        </Text>
      )}
      {getEventsState?.isLoaded &&
        Array.isArray(eventDropdownOptions) &&
        eventDropdownOptions.length === 0 && (
          <Text variant="body2" color={COLORS.PRIMARY}>
            No events on {formattedDate}
          </Text>
        )}
      {getEventsState?.isLoaded &&
        Array.isArray(eventDropdownOptions) &&
        eventDropdownOptions.length > 0 && (
          <InputContainer>
            <Dropdown
              type="primary"
              width="250px"
              height="auto"
              label="Select Event Name"
              name={'event-name'}
              value={eventName}
              options={eventDropdownOptions}
              onChange={value => handleFormChange('eventName', value)}
            />
            {!!eventName && (
              <TextInput
                onChange={value => handleFormChange('certificateEventName', value)}
                width="250px"
                type="text"
                label="Certificate event name"
                name={'certificate-event-name'}
                value={certificateEventName || ''}
              />
            )}
          </InputContainer>
        )}
      {eventName && (
        <>
          <Separator height={24} />
          <Row alignItems="center">
            <div>
              <label htmlFor="file-upload">
                <Upload size="40" />
              </label>
              <input
                style={{ display: 'none' }}
                type="file"
                id="file-upload"
                onChange={e => handleFormChange('eventDataFile', e.target.files[0])}
                accept=".xlsx"
                onClick={e => (e.target.value = null)}
              />
            </div>
            <Text variant="body2" color={COLORS.PRIMARY}>
              {fileName || 'Upload .xlsx file by click on the icon'}
            </Text>
          </Row>
          <Separator height={8} />
          <Text variant="body2" color={COLORS.PRIMARY}>
            File name format: Grade [g1]-[g2] - [quiz-name].xlsx
          </Text>
          <Separator height={24} />
          <Button
            label="Upload"
            variant="primary"
            size="small"
            onClick={() => handleUpload()}
            isDisabled={!fileName}
            isBusy={uploadingFileInProgress}
          />
        </>
      )}
      <Separator height={24} />
      {eventName &&
        (getReportDetailsInProgress ? (
          <Text variant="body2" color={COLORS.PRIMARY}>
            Loading all available reports of the {eventName ? eventName : 'event'}
          </Text>
        ) : (
          <ReportList
            eventName={eventName}
            reports={previouslyUploadedReports}
            handleGetFestReport={handleGetFestReport}
            sendCommsToParticipants={sendCommsToParticipants}
          />
        ))}
    </Container>
  );
};

View.propTypes = {
  formData: PropTypes.shape({}).isRequired,
  handleUpload: PropTypes.func.isRequired,
  getEventsState: PropTypes.shape({}).isRequired,
  handleGetFestReport: PropTypes.func.isRequired,
  handleFormChange: PropTypes.func.isRequired,
  eventDropdownOptions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  uploadingFileInProgress: PropTypes.bool.isRequired,
  getReportDetailsInProgress: PropTypes.bool.isRequired,
  previouslyUploadedReports: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default View;
